// Dependencies
import React from 'react';
import { Button, Box, Text } from '@nerdwallet/currency';

// Local Components
import ApiErrorIcon from '../../../api-error-icon/api-error-icon';

// CSS
import style from './city-results-error.module.less';

type CityErrorProps = {
  onRefreshClick?: () => void;
};

const CityResultsError = ({
  onRefreshClick = () => {},
}: CityErrorProps): JSX.Element => (
  <Box align="center" marginBottom={5}>
    <ApiErrorIcon />
    <Box marginLeft={0} marginBottom={3}>
      <Text> We didn’t catch any city data.</Text>
    </Box>
    <Box>
      <Button primary onClick={onRefreshClick} className={style.refresh}>
        Try Again
      </Button>
    </Box>
  </Box>
);

CityResultsError.displayName = 'CityResultsError';

export default CityResultsError;
